<template>
  <responsive-header :has-drawer="false">
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:right>
      <telemetrie-date-picker v-model="datePickerValue"></telemetrie-date-picker>
    </template>
  </responsive-header>
</template>

<script>
import ResponsiveHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import common from '@/mixins/common';
import dateUtils from '@/common/dateUtils';
import TelemetrieDatePicker from '@/modules/telemetrie/components/TelemetrieDatePicker.vue';

export default {
  name: 'Telemetrie',
  mixins: [common],
  components: {
    TelemetrieDatePicker,
    ResponsiveHeader,
  },
  data() {
    return {
      dateRoute: {
        from: this.getDateFromRouteOrToday(),
        to: this.getDateToRouteOrToday(),
      },
      datePickerValue: null,
    };
  },
  created() {
    const { from, to } = this.dateRoute;
    const newFrom = dateUtils.reformatDateIsoStringAsYYYYMMDD(from.toISOString());
    const newTo = dateUtils.reformatDateIsoStringAsYYYYMMDD(to.toISOString());

    if (
        this.$route.name !== 'telemetrie-range-date' ||
        this.$route.params.from !== newFrom ||
        this.$route.params.to !== newTo
    ) {
      this.$router.replace({
        name: 'telemetrie-range-date',
        params: {
          from: newFrom,
          to: newTo,
        },
      });
    }
  },
  methods: {
    getDateFromRouteOrToday() {
      return this.$route.params.from ? new Date(this.$route.params.from) : new Date();
    },
    getDateToRouteOrToday() {
      return this.$route.params.to ? new Date(this.$route.params.to) : new Date();
    },
    /**
     *
     * @param {object} date
     */
    handleDateChange(date) {
      this.datePickerValue = date;
    },
  },
  watch: {
    datePickerValue(newValue) {
      const dateFromFormatted = dateUtils.formatDateAsYYYYMMDD(newValue.from);
      const dateToFormatted = dateUtils.formatDateAsYYYYMMDD(newValue.to);
      if (this.$route.params.from !== dateFromFormatted || this.$route.params.to !== dateToFormatted) {
        this.$router.replace({name: 'telemetrie-range-date', params: {from: dateFromFormatted, to: dateToFormatted}});
      }
    },
  },
};
</script>

<style scoped></style>
